import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../elements/Humberg.jsx";

import { useDispatch, useSelector } from "react-redux";
import { allBlockedEmailsAction, clearErrors, createBlockeEmailAction } from "../../redux/actions/userActions.js";
import SingleBl0ckedMails from "./SingleBlockedMail.jsx";
import LoaderBlock from "../loader/LoaderBlock.jsx";
import { toast } from "react-toastify";
import { CREATE_BLOCKED_EMAIL_RESET } from "../../redux/constants/userConstant.js";
import Loader from "../loader/loader.jsx";

const BlockedMails = () => {
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.verifyEmailStore)
    const { loading: loadingBlockedEmails, blockedEmails, totalblockedEmails, totalPages } = useSelector(state => state.blockedEmails)
    const {  error, message } = useSelector(state => state.register)

    const [keyword, setKeyword] = useState('');
    const [email, setEmail] = useState('');
    const [perPage, setPerPage] = useState('10');
    const [page, setPage] = useState('1');

    useEffect(() => {
        document.title = `Blocked Emails`;
    }, []);

    useEffect(() => {
        let query = {}
        if (keyword) query.keyword = keyword
        if (perPage) query.perPage = perPage
        query.page = page
        dispatch(allBlockedEmailsAction(query))
    }, [keyword, perPage, page, dispatch])

    useEffect(() => {
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            toast.success(message)
            dispatch({ type: CREATE_BLOCKED_EMAIL_RESET })
            dispatch(allBlockedEmailsAction())
            setEmail('')
        }
    }, [error, message, dispatch])

    const handleSubmit = () => {
        if (!email) return toast.error("Please enter an email address")
        dispatch(createBlockeEmailAction({ email }))
    }

    return (
        <Fragment>
            {loadingBlockedEmails && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={"Blocked Mails"} />
            
            <section className="p-[1.5vmax] mt-[1vmax]">
                {/* Add to Blacklist Section */}
                {(user?.role === "SUPER_ADMIN" || user?.role === "ADMIN") &&
                    <div className="bg-white p-[2vmax] shadow-1 rounded-xl mb-[2vmax] border-l-[0.4vmax] border-indigo-600">
                        <h2 className="text-[1.5vmax] lg:text-[1.1vmax] font-bold text-gray-800 mb-[1.5vmax] flex items-center gap-2">
                            <i className="fa-solid fa-user-slash text-indigo-600"></i>
                            Add Email to Blacklist
                        </h2>
                        <div className="flex flex-col lg:flex-row gap-[1vmax]">
                            <div className="flex-1 relative">
                                <i className="fa-regular fa-envelope absolute left-[1vmax] top-1/2 -translate-y-1/2 text-gray-400"></i>
                                <input 
                                    type="text" 
                                    className="w-full pl-[3vmax] pr-[1vmax] py-[0.8vmax] text-[1.5vmax] lg:text-[1vmax] font-medium outline-none bg-gray-50 border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 rounded-xl transition-all" 
                                    placeholder="Enter email address to block..."
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <button 
                                className={`bg-indigo-600 hover:bg-indigo-700 py-[0.8vmax] px-[3vmax] rounded-xl text-white font-bold shadow-md transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2`}
                                disabled={!email}
                                onClick={handleSubmit}
                            >
                                <i className="fa-solid fa-plus text-[0.9vmax]"></i>
                                Add to Blacklist
                            </button>
                        </div>
                    </div>
                }

                {/* Filters Section */}
                <div className="bg-white p-[1.5vmax] shadow-1 rounded-t-xl border-b border-gray-50">
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-[1.5vmax]">
                        <div className="flex items-center gap-3">
                            <div className="w-[0.4vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                            <h3 className="text-[1.4vmax] lg:text-[1.1vmax] font-bold text-gray-800">Search Filters</h3>
                        </div>
                        
                        <div className="flex flex-wrap items-center gap-[1.5vmax] w-full lg:w-auto">
                            {/* Search */}
                            <div className="relative flex-1 lg:w-[20vmax]">
                                <i className="fa-solid fa-magnifying-glass absolute left-[1vmax] top-1/2 -translate-y-1/2 text-gray-400"></i>
                                <input 
                                    type="text" 
                                    className="w-full pl-[3vmax] pr-[1vmax] py-[0.6vmax] bg-gray-50 border border-gray-200 rounded-lg outline-none focus:border-indigo-500 transition-colors text-[0.9vmax]" 
                                    placeholder="Search blocked emails..."
                                    value={keyword}
                                    onChange={(e) => {
                                        setKeyword(e.target.value)
                                        setPage(1)
                                    }}
                                />
                            </div>

                            {/* Per Page */}
                            <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 px-[0.8vmax] py-[0.6vmax] rounded-lg">
                                <i className="fa-solid fa-list-ul text-gray-400 text-[0.9vmax]"></i>
                                <select 
                                    className="bg-transparent outline-none text-gray-600 font-medium text-[0.9vmax] cursor-pointer"
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(e.target.value)
                                        setPage(1)
                                    }}
                                >
                                    <option value="10">10 Rows</option>
                                    <option value="20">20 Rows</option>
                                    <option value="50">50 Rows</option>
                                    <option value="100">100 Rows</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                <div className="bg-white p-[1.5vmax] shadow-1 rounded-b-xl overflow-x-auto my-scroll-2 my-scroll-3">
                    <div className="flex w-[150%] lg:w-full bg-gray-50 py-[0.8vmax] items-center rounded-xl mb-[1vmax] border border-gray-100">
                        <div className="text-center flex-[0.5] text-gray-500 font-bold uppercase text-[0.8vmax]" >
                            No.
                        </div>
                        <div className="px-[1vmax] flex-[2] text-gray-500 font-bold uppercase text-[0.8vmax]" >
                            Blocked Email Address
                        </div>
                        <div className="text-center px-[0.5vmax] flex-[1] text-gray-500 font-bold uppercase text-[0.8vmax]" >
                            Blocked Date
                        </div>
                        {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") &&
                            <div className="text-center px-[0.5vmax] flex-[1] text-gray-500 font-bold uppercase text-[0.8vmax]" >
                                Action
                            </div>
                        }
                    </div>

                    <div className="flex flex-col gap-[0.8vmax]">
                        {loadingBlockedEmails ? (
                            <LoaderBlock />
                        ) : blockedEmails?.length > 0 ? (
                            blockedEmails.map((blockEmail, index) => (
                                <SingleBl0ckedMails 
                                    key={blockEmail.email} 
                                    blockEmail={blockEmail} 
                                    index={index} 
                                    totalblockedEmails={totalblockedEmails} 
                                    user={user} 
                                />
                            ))
                        ) : (
                            <div className="text-center py-[5vmax] bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
                                <i className="fa-solid fa-inbox text-[3vmax] text-gray-300 mb-3 block"></i>
                                <span className="text-gray-400 font-medium">No blocked emails found</span>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[3vmax] mb-[5vmax]">
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        <i className="fa-solid fa-chevron-left mr-2"></i>
                        Prev
                    </button>

                    {(() => {
                        const pages = [];
                        const maxVisible = 2;
                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        addPage(1);
                        if (page > maxVisible + 2) pages.push(<span key="dots-left" className="self-end pb-2">...</span>);
                        for (let p = Math.max(2, page - maxVisible); p <= Math.min(totalPages - 1, page + maxVisible); p++) addPage(p);
                        if (page < totalPages - (maxVisible + 1)) pages.push(<span key="dots-right" className="self-end pb-2">...</span>);
                        if (totalPages > 1) addPage(totalPages);
                        return pages;
                    })()}

                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                        <i className="fa-solid fa-chevron-right ml-2"></i>
                    </button>
                </div>
            )}
        </Fragment>
    );
};

export default BlockedMails;
